<template>
	<Teleport to="body">
		<div
			class="pointer-events-none fixed top-[calc(var(--tg-safe-area-inset-top,0px)+var(--tg-content-safe-area-inset-top,0px))] right-0 bottom-0 left-0 z-51 px-4 pt-2"
		>
			<TransitionGroup
				enterFromClass="-translate-y-[calc(100%+72px)] opacity-0"
				leaveToClass="-translate-y-[calc(100%+72px)] -mb-12 opacity-0"
				tag="div"
				class="flex w-full flex-col items-center"
			>
				<ToastItem
					v-for="(item, i) in toast.list"
					:key="item.id"
					:type="item.type"
					:text="item.text"
					:action="item.action?.text"
					class="transition-all duration-500 ease-in-out *:transition-all *:duration-500 *:ease-in-out"
					:class="{
						'!bg-fill-tertiary pointer-events-none -mt-10 h-12 w-11/12 opacity-0 *:opacity-0':
							i >= 2,
						'!bg-fill-tertiary pointer-events-none z-0 -mt-10 h-12 w-11/12 *:opacity-0':
							i === 1,
						'pointer-events-auto z-1 w-full': i === 0
					}"
					@action="action(item)"
				/>
			</TransitionGroup>
		</div>
	</Teleport>
</template>
<script setup lang="ts">
import { useToast } from '@/stores/toast'
import ToastItem from './ToastItem.vue'

const toast = useToast()

const action = (item: { id: number; action?: { onClick: () => void } }) => {
	if (item.action) {
		item.action.onClick()
	}

	toast.remove(item.id)
}
</script>
